import { render, staticRenderFns } from "./AulasMinistradasExigidas.vue?vue&type=template&id=36926d9b&"
import script from "./AulasMinistradasExigidas.vue?vue&type=script&lang=js&"
export * from "./AulasMinistradasExigidas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports